export const ru = {
    title: 'Командировка завершена',
    description: 'Если все прошло хорошо или, наоборот, были какие-то трудности, напишите нам об этом',
    send_feedback: 'Оставить отзыв',
};
